// Start of jQuery .initialized() library
(function ($) {
    "use strict";
    var combinators = [" ", ">", "+", "~"];
    var fraternisers = ["+", "~"];
    var complexTypes = ["ATTR", "PSEUDO", "ID", "CLASS"];
    function grok(msobserver) {
        if (!$.find.tokenize) {
            msobserver.isCombinatorial = true;
            msobserver.isFraternal = true;
            msobserver.isComplex = true;
            return;
        }
        msobserver.isCombinatorial = false;
        msobserver.isFraternal = false;
        msobserver.isComplex = false;
        var token = $.find.tokenize(msobserver.selector);
        for (var i = 0; i < token.length; i++) {
            for (var j = 0; j < token[i].length; j++) {
                if (combinators.indexOf(token[i][j].type) != -1) msobserver.isCombinatorial = true;
                if (fraternisers.indexOf(token[i][j].type) != -1) msobserver.isFraternal = true;
                if (complexTypes.indexOf(token[i][j].type) != -1) msobserver.isComplex = true;
            }
        }
    }
    var MutationSelectorObserver = function (selector, callback, options) {
        console.log(selector);
        if(selector == undefined){
            this.selector = '';
        }else{
            this.selector = selector.trim();
        }
        
        this.callback = callback;
        this.options = options;
        grok(this);
    };
    var msobservers = [];
    msobservers.initialize = function (selector, callback, options) {
        var seen = [];
        var callbackOnce = function () {
            if (seen.indexOf(this) == -1) {
                seen.push(this);
                $(this).each(callback);
            }
        };
        $(options.target).find(selector).each(callbackOnce);
        var msobserver = new MutationSelectorObserver(selector, callbackOnce, options);
        this.push(msobserver);
        var observer = new MutationObserver(function (mutations) {
            var matches = [];
            for (var m = 0; m < mutations.length; m++) {
                if (mutations[m].type == "attributes") {
                    if (mutations[m].target.matches(msobserver.selector)) matches.push(mutations[m].target);
                    if (msobserver.isFraternal) matches.push.apply(matches, mutations[m].target.parentElement.querySelectorAll(msobserver.selector));
                    else matches.push.apply(matches, mutations[m].target.querySelectorAll(msobserver.selector));
                }
                if (mutations[m].type == "childList") {
                    for (var n = 0; n < mutations[m].addedNodes.length; n++) {
                        if (!(mutations[m].addedNodes[n] instanceof Element)) continue;
                        if (mutations[m].addedNodes[n].matches(msobserver.selector)) matches.push(mutations[m].addedNodes[n]);
                        if (msobserver.isFraternal) matches.push.apply(matches, mutations[m].addedNodes[n].parentElement.querySelectorAll(msobserver.selector));
                        else matches.push.apply(matches, mutations[m].addedNodes[n].querySelectorAll(msobserver.selector));
                    }
                }
            }
            for (var i = 0; i < matches.length; i++) $(matches[i]).each(msobserver.callback);
        });
        var defaultObeserverOpts = { childList: true, subtree: true, attributes: msobserver.isComplex };
        observer.observe(options.target, options.observer || defaultObeserverOpts);
        return observer;
    };
    $.fn.initialize = function (callback, options) {
        return msobservers.initialize(this.selector, callback, $.extend({}, $.initialize.defaults, options));
    };
    $.initialize = function (selector, callback, options) {
        return msobservers.initialize(selector, callback, $.extend({}, $.initialize.defaults, options));
    };
    $.initialize.defaults = { target: document.documentElement, observer: null };
})(jQuery);
// End of jQuery .initialized() library

import header from "./inc/_header";
import showDetails from "./inc/_showDetails";
import calendar from "./inc/_calendar";
import sliderPosts from "./inc/_slider-posts";
// import videoPreview from "./inc/_videoPreview";
import menuDropdown from "./inc/_menuDropdown";
import authorsSearch from "./inc/_authorsSearch";
import authorContributions from "./inc/_authorContributions";
import commentaryToolbar from "./inc/_commentaryToolbar";
import print from "./inc/_print";
import bibleIndexFilter from "./inc/_bibleIndexFilter";
import accordion from "./inc/_accordion";
import socialShare from "./inc/_social-share";
import filter from "./inc/_filter";
import gform from "./inc/_gform";
import captionBlock from "./inc/_captionBlock";

header.init();
showDetails.init();
calendar.init();
sliderPosts.init();
// videoPreview.init();
menuDropdown.init();
authorsSearch.init();
authorContributions.init();
commentaryToolbar.init();
print.init();
gform.init();
bibleIndexFilter.init();
accordion.init();
socialShare.init();
filter.init();
captionBlock.init();
